import { AxiosResponse } from "axios";
import { axiosClient } from "../../axiosClient";
import { axiosSafeRequest } from "../../axiosSafeRequest";

/**
 * Generate session cookie for a single customer.
 *
 * @param token The recipient authentication token.
 * @param email The recipient email address.
 * @returns An HTTP response.
 */
export const apiAccountAuthorizeGet = async (token: string, email: string): Promise<AxiosResponse | undefined> => {
  return axiosSafeRequest(() => axiosClient.post(`/account/authorize`, { token, email }));
}
